import { User } from '../api/user';

export const PROFILE_MANDATORY_FIELDS_TO_SUBMIT_KLYDO: (keyof User)[] = [
  'name',
  'country',
  'description',
  'photoUrl',
];

export const PROFILE_REQUIRED_FIELDS_FOR_STUDIO_REGISTRATION: (keyof User)[] = [
  'name',
];
